module.exports = __webpack_public_path__ + "static/img/来访-3.040eb182.png";